Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var _reactNativeSafeAreaContext = require("react-native-safe-area-context");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    fontBold = _STYLES$useStyles.fontBold,
    COLORS = _STYLES$useStyles.COLORS,
    fontRegular = _STYLES$useStyles.fontRegular,
    boxShadows = _STYLES$useStyles.boxShadows;
  var insets = (0, _reactNativeSafeAreaContext.useSafeAreaInsets)();
  var container = Object.assign({
    position: _reactNative.Platform.OS === 'web' ? 'fixed' : 'absolute',
    top: 0 + insets.top,
    left: 0,
    right: 0,
    zIndex: 99,
    backgroundColor: COLORS.white,
    paddingVertical: (0, _styles.getREM)(0.25),
    paddingHorizontal: (0, _styles.getREM)(0.5),
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: (0, _styles.getREM)(2.25)
  }, boxShadows.button.all);
  var container__alert = {
    backgroundColor: COLORS.peach
  };
  var container__notice = {
    backgroundColor: COLORS.apple
  };
  var indicator = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    backgroundColor: COLORS.white,
    height: (0, _styles.getREM)(0.125)
  };
  var close = Object.assign({}, fontBold, {
    marginLeft: (0, _styles.getREM)(0.5),
    marginRight: (0, _styles.getREM)(0.125),
    justifyContent: 'center',
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s
  });
  var text = Object.assign({}, fontRegular, {
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s,
    flexShrink: 1,
    alignSelf: 'center',
    textAlign: 'center',
    width: 'auto'
  });
  var styles = _reactNative.StyleSheet.create({
    container: container,
    container__alert: container__alert,
    container__notice: container__notice,
    indicator: indicator,
    text: text,
    close: close
  });
  return {
    styles: styles
  };
};